import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const committeeProofApi = generateProofApi('/proof-file/committee');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('committee', committeeProofApi);

export function getCommitteeProofsByOwnerOptions(committeeId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(committeeId, userId);
}

export function getCommitteeProofsOptions(committeeId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(committeeId);
}

export function useUploadOrUpdateCommitteeProof(committeeId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(committeeId, queryClient));
}

export function useDeleteCommitteeProof(committeeId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(committeeId, queryClient));
}
